import axios from '../../axios/index';
import { BASE_PATH } from './SEARCH_BASE_PATH';
import {
  GuamRawSearchCarDefinedRSType,
  HertzRawSearchCarDefinedRSType,
} from './Search.response.types';
import { OTSearchDefinedCarRSType } from '../../api2/OTClientAPI/otClientAPI.ResponseType';
export const searchCity = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  const response = await axios.fetch({
    url: `${BASE_PATH}?${queryString}`,
    method: 'get',
  });
  return response;
};

export const searchVehAvail = async (params) => {
  const response = await axios.fetch({
    url: `${BASE_PATH}/cars`,
    method: 'get',
    data: params,
  });
  return response;
};

export const getNewVehAvail = async (key) => {
  const response = await axios.fetch({
    url: `${BASE_PATH}/cars/loading?key=${key}`,
    method: 'get',
  });
  return response;
};

export const isExistKey = async (key) => {
  const response = await axios.fetch({
    url: `${BASE_PATH}/cars/exists?key=${key}`,
    method: 'get',
  });
  return response.data;
};

export const searchCarsByLocationGroup = async (params) => {
  axios.fetch({
    url: `${BASE_PATH}/cars/location`,
    method: 'post',
    data: params,
  });
};

export const searchDefinedCarRenewal = async (params) => {
  const response = await axios.fetch<GuamRawSearchCarDefinedRSType>({
    url: `${BASE_PATH}/cars/defined`,
    method: 'post',
    data: params,
  });
  return response;
};

export const searchDefinedCarHertz = async (params) => {
  const response = await axios.fetch<HertzRawSearchCarDefinedRSType>({
    url: `${BASE_PATH}/cars/defined`,
    method: 'post',
    data: params,
  });
  return response;
};

export const checkEquips = async (params) => {
  const response = await axios.fetch({
    url: `${BASE_PATH}/cars/equips`,
    method: 'post',
    data: params,
  });
  return response;
};

export const testConnecttion = async () => {
  const response = await axios.fetch({
    url: '/redis',
    method: 'get',
  });
  return response;
};

export const searchOTDefinedCar = async (params) => {
  const queryString = new URLSearchParams(params).toString();
  const startTime = performance.now();
  const response = await axios.fetch<OTSearchDefinedCarRSType>({
    url: `${BASE_PATH}/cars/defined/onlineTravel?${queryString}`,
    method: 'get',
  });
  return response;
};
